/**
 * Единый ввод российского номера: отображение +7 (999) 999-99-99, отправка в API в E.164 (+7XXXXXXXXXX).
 */

function toDigitString(input: string): string {
  let digits = (input || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("8")) {
    digits = "7" + digits.slice(1);
  }
  if (digits.startsWith("7")) {
    const rest = digits.slice(1).replace(/^7+/g, "");
    return ("7" + rest).slice(0, 11);
  }
  return ("7" + digits).slice(0, 11);
}

/** Маска для контролируемого input */
export function formatRuPhoneInput(value: string): string {
  const d = toDigitString(value);
  if (!d) return "";
  if (d.length <= 1) return "+7 ";
  const body = d.slice(1);
  let s = "+7 (" + body.slice(0, 3);
  if (body.length < 3) return s;
  s = "+7 (" + body.slice(0, 3) + ") " + body.slice(3, 6);
  if (body.length <= 6) return s;
  s = "+7 (" + body.slice(0, 3) + ") " + body.slice(3, 6) + "-" + body.slice(6, 8);
  if (body.length <= 8) return s;
  return (
    "+7 (" +
    body.slice(0, 3) +
    ") " +
    body.slice(3, 6) +
    "-" +
    body.slice(6, 8) +
    "-" +
    body.slice(8, 10)
  );
}

/** Нормализация для тел запросов (E.164). */
export function normalizeToE164(value: string): string {
  const d = toDigitString(value);
  if (d.length !== 11) return d.length > 1 ? "+" + d : "";
  return "+" + d;
}
